export default __webpack_public_path__ + "static/media/49.a90bf1ac.jpg";